import { useOverlays } from "contexts/OverlayContext";
import { TransactionMatchDrawer } from "./TransactionMatchDrawer";

export const TransactionMatchDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    const overlayInfo = getOverlayInfo<"transactionMatch">("transactionMatch");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <TransactionMatchDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            transactionId={overlayInfo.data.transactionId}
            suggestedItems={overlayInfo.data.suggestedItems}
        />
    );
};
